module Enums {
	export const enum FotoEpisodeSetupResponseCode {
		Success = 0,
		PatientSetupFailed = 1,
		EpisodeSetupFailed = 2,
		AuthenticationFailed = 3,
		MissingConfiguration = 4,
		MissingVisitData = 5,
		MissingPatientInformation = 6,
		UnspecifiedError = 500
	}
}
module Enums {
	export const enum WoundExpertFileType {
		WoundAssessment = 1,
		Tcom = 2,
		Patient = 3,
		FacilityHeader = 4,
		FacilityFooter = 5,
		Lymphedema = 6,
		BurnAssessment = 7,
		ScarAssessment = 8,
		StomaAssessment = 9,
		CustomScans = 10,
		EducationHandoutContent = 11,
		EducationHandoutFooter = 12,
		PhysicianDictation = 13,
		TestResults = 14,
		Debridement = 15,
		TrueSeeOriginalWound = 16,
		TrueSeeOriginalDebridement = 17,
		Attachment = 18,
		PainDiagram = 19,
		TCOMDiagram = 20,
		NeuropathyDiagram = 21,
		EPCSAuditLog = 22,
		Profile = 23,
		FacilityBanner = 24,
		Temporary = 99,
		HEP = 25,
		CQM = 26,
		PatientStatementConfiguration = 27,
		Faxes = 28
	}
}
module Enums {
	export const enum EnumEditorMode {
		Normal = 0,
		CriticalFieldEditor = 1
	}
	export const enum EnumCriticalEditorViewMode {
		None = 0,
		Standard = 1,
		Extended = 2,
		Preview = 3
	}
	export const enum EnumRequiredMode {
		NotRequired = 0,
		Recommended = 1,
		Required = 2
	}
	export const enum EnumCustomQuestionControlType {
		Textbox = 1,
		DateControl = 2,
		CheckBoxList = 3,
		DropDown = 4,
		TimeControl = 5,
		RadioButton = 6,
		NumericTextBox = 7
	}
	export const enum DisciplineOptionScope {
		OT = 0,
		SLP = 1,
		PT = 2
	}
	export const enum EligibiliyCoverage {
		InActive = 0,
		Active = 1,
		Error = 2
	}
	export const enum FunctionalProblemsScope {
		Global = 2,
		Facility = 1
	}
	export const enum ServerDataType {
		LeftNavigation = 0,
		ProfileMenu = 1,
		FacilityMenu = 2,
		BaseData = 3,
		ActiveMessages = 4,
		ConnectionsDocumentTypes = 5
	}
}
module Enums {
	export const enum ReportType {
		PaginatedReport = 0,
		Report = 1,
		Dashboard = 2,
		ReportVisual = 3
	}
	export const enum PayerRuleActionType {
		IcdCpt = 0,
		NcciPair = 1,
		Ncci = 2
	}
	export const enum ExportFormat {
		AllEhi = 1,
		CdaSummary = 2,
		Csv = 3,
		Pdf = 4
	}
	export const enum VisitTypeCategory {
		Appointment = 0,
		NonBillableInteraction = 1
	}
	export const enum PatientSyncRequestType {
		DigitalIntake = 1,
		ReputationRequest = 2,
		AppointmentReminders = 3,
		PatientPortal = 4,
		PatientMessaging = 5
	}
	export const enum FaxContentTypes {
		PatientReports = 1,
		TherapyReports = 2,
		AggregateDocuments = 5,
		IndividualDocuments = 3,
		CustomScans = 4
	}
	export const enum AdjustmentReasons {
		WithholdAdjustment = 2,
		AdjustPerOffice = 277,
		Adjustment3_WO_NotbillingToSecondary = 1826,
		Adjustment4_WriteOffSmallBal = 6,
		Adjustment4a_NoPrecertification = 186,
		Adjustment5_IndigentCare = 114,
		Adjustment5a_Charity = 187,
		Adjustment6_Collections = 147,
		Adjustment7_Administrative_Regulatory = 23,
		Adjustment8_Bankruptcy = 153,
		AdjustmentOutofNetwork = 507,
		ApprovedAdjustment = 317,
		AuditAdjustment = 231,
		BackupWithholding = 502,
		BadDebtAdjustment = 271,
		BankruptcyAdjustment = 3010,
		CapitationAdjustment = 210,
		CourtesyAdjustment = 249,
		DiscountCoupon = 273,
		EmployeeDiscount = 28,
		ErrorAdjustment = 10,
		FilingTimeExpired_CO_29 = 99,
		HardshipAdjustment = 316,
		InsuranceFlatRate = 1858,
		LatePenaltyAdjustment = 41,
		OfficeDiscount = 279,
		Offset_Refund_Adj = 93,
		Over_U_And_C_Adjustment = 12,
		Overpayment_Adjustment_DR = 5010,
		PatientDeceased = 152,
		PayerProcessingErrorAdjustment = 3005,
		PostingError_Adjustment = 1843,
		PrivatePayAdjustment = 3033,
		PromotionalDiscount = 208,
		PromptPayAdjustment = 100,
		ProtocolAdjustment = 314,
		ProviderDiscount = 225,
		ProviderType_and_or_facility_adjustment = 197,
		Returned_Mail_Coll_Agency = 105,
		SiteOfServiceReduction = 222,
		SmallBalanceWriteOff = 144,
		SubsequentProcAdj = 242,
		UncollectibleAdjustment = 238,
		VA_WriteOff = 3028,
		W_C_Record_Fee_Waived = 240,
		WO_SentToCollections = 1862
	}
	export const enum AlertAction {
		NoAction = 0,
		Warning = 1,
		Error = 2,
		Popup = 3
	}
	export const enum FacilityNoteType {
		Scheduler = 1,
		Patient = 2,
		TreatmentCycle = 3,
		Visit = 4
	}
	export const enum MedicalDocsValidationType {
		Required = 1,
		Recommended = 2
	}
	export const enum CmsReportingType {
		PI = 0,
		CQM = 1,
		Both = 2
	}
	export const enum CmsReportingAs {
		Individual = 0,
		Group = 1
	}
	export const enum ExerciseListLibraryTemplateOptionLibrary {
		Exercises = 0,
		Protocols = 1
	}
	export const enum ExerciseListLibraryTemplateOptionScope {
		Facility = 1,
		Global = 2,
		User = 3
	}
	export const enum DepartmentSetupOptionScope {
		Facility = 1,
		Global = 2
	}
	export const enum ExerciseProtocolScope {
		Facility = 2,
		ComponentOfCare = 1,
		User = 0
	}
	export const enum InpatientClinicianAssignmentResult {
		Success = 0,
		ClinicianNotInRole = 1,
		UnknownFailure = 2
	}
	export const enum DEAClassification {
		ScheduleI = 1,
		ScheduleII = 2,
		ScheduleIIII = 3,
		ScheduleIV = 4,
		ScheduleV = 5,
		MultipleValues = 6,
		NoValue = 9,
		NotScheduled = 100
	}
	export const enum RxNormType {
		SCD = 501,
		SBD = 502,
		GPK = 503,
		BPK = 504
	}
	export const enum MedicationCancelStatus {
		Pending = 1,
		Cancelled = 2,
		Denied = 3
	}
	export const enum PayerAlertType {
		DiagnosisAlert = 0,
		PayerRule = 1
	}
	export const enum PayerRuleAction {
		Recommended = 0,
		NotAllowed = 1,
		AllowedWithModifiers = 2,
		AutomateModifier = 3
	}
	export const enum PayerRuleType {
		AllInsurances = 0,
		InsurancePlan = 1,
		PayerId = 2,
		InsuranceType = 3
	}
	export const enum PediatricSpeechOptionLibrary {
		TypicalPhonologicalProcessesCharacteristicOfNormalSpeechDevelopmentPresent = 0,
		AtypicalPhonologicalProcessesNotCharacteristicOfNormalSpeechDevelopmentPresent = 1,
		ImpactCompensationsReducedSpeechIntelligibility = 2
	}
	export const enum PediatricSpeechOptionScope {
		Facility = 1,
		Global = 2
	}
	export const enum BarrierGoalOptionLibrary {
		PatientCaregiverGoal = 0,
		ClinicianLongTermGoal = 1,
		ClinicianShortTermGoal = 2,
		BarrierToIndependence = 3,
		FunctionalProblems = 4,
		ImpairmentsOptions = 5,
		OutcomeInfluencingFactors = 6,
		StrengthPositiveExpectations = 7
	}
	export const enum BarrierGoalOptionScope {
		Facility = 1,
		Global = 2
	}
	export const enum PediatricSchoolLanguageOptionLibrary {
		PrimaryMeansofCommunication = 0,
		AugmentativeCommunication = 1,
		PlayStageObservedReported = 2,
		EarlySoundDevelopmentObserved = 3,
		ExpressiveVocabularyObserved = 4,
		EarlyGrammarMorphology = 5,
		GrammarSyntax = 6,
		PragmaticsProductionObserved = 7,
		VerbalExpressionObserved = 8,
		WrittenMechanics = 9,
		WrittenExpression = 10,
		ReceptiveVocabulary = 11,
		AuditoryComprehension = 12,
		PragmaticsComprehension = 13,
		PhonologicalAwareness = 14,
		PreLiteracySkills = 15,
		ReadingComprehension = 16
	}
	export const enum PediatricSchoolLanguageOptionScope {
		Facility = 1,
		Global = 2
	}
	export const enum InfantPediatricFeedingOptionLibrary {
		EnteralFeedingEnteralNutrition = 0,
		EnteralFeedingPositionDuringFeeding = 1,
		EnteralFeedingAssociatedBehaviors = 2,
		BreastFeedingPositionDuringFeeding = 3,
		BreastFeedingInfantResponseDuringFeeding = 4,
		BreastFeedingAssociatedBehaviors = 5,
		BottleFeedingNipple = 6,
		BottleFeedingPositionDuringfeeding = 7,
		BottleFeedingInfantResponseDuringFeeding = 8,
		BottleFeedingAssociatedBehaviors = 9,
		CupStrawDrinkingPresentation = 10,
		CupStrawDrinkingContents = 11,
		CupStrawDrinkingPositionDuringFeeding = 12,
		CupStrawDrinkingAssociatedbehaviors = 13,
		SolidFoodIntakeFeedingMethods = 14,
		SolidFoodIntakeAdaptiveEquipment = 15,
		SolidFoodIntakePositionDuringFeeding = 16,
		SolidFoodIntakeTemperaturePreference = 17
	}
	export const enum ProgressNoteTsSection {
		Subjective = 1,
		Objective = 2,
		Assessment = 3,
		Diagnosis = 4,
		Plan = 5,
		Procedure = 6
	}
	export const enum SchedulingResourceTypes {
		PrimaryProvider = 1,
		SecondaryProvider = 2,
		Assistant = 4,
		AncillaryStaff = 8,
		Patient = 16,
		Room = 32,
		Equipment = 64
	}
	export const enum SchedulingConflictType {
		Unknown = 0,
		PatientAppointment = 1,
		ReservedTime = 2,
		ProviderAppointment = 3,
		ProviderSchedule = 4,
		OfficeHours = 5,
		PhysicianSchedule = 6
	}
	export const enum VisitRecurringScheduleInterval {
		Weekly = 1,
		EveryOtherWeek = 2,
		EveryThirdWeek = 3,
		EveryFourthWeek = 4,
		FirstWeekOfMonth = 5,
		SecondWeekOfMonth = 6,
		ThirdWeekOfMonth = 7,
		FourthWeekOfMonth = 8
	}
	export const enum MissedVisitPredictionBucket {
		Low = 1,
		Medium = 2,
		High = 3
	}
	export const enum ReservedTimeRecurringInterval {
		Daily = 0,
		Weekly = 1,
		Monthly = 2,
		Yearly = 3
	}
	export const enum SensoryProcessingOptionLibrary {
		SensoryTolerance = 0,
		PraxisMotorPlanning = 1,
		VestibularFunction = 2,
		KinesthesiaBodyAwareness = 3,
		BilateralIntegration = 4,
		RegistrationOfSensoryInput = 5,
		AuditoryProcessing = 6,
		Proprioception = 7,
		SelfRegulationArousal = 8,
		SelfStimulatoryBehavior = 9
	}
	export const enum SpirometryCalculationMethods {
		Knudson1987 = 0,
		JMorris = 1,
		Eccs = 2,
		Knudson1976 = 3,
		Knudson1983 = 4,
		NHanes1999 = 5
	}
	export const enum StandardizedTestsTemplateOptionLibrary {
		StandardizedTests = 0,
		TargetSkills = 1
	}
	export const enum StandardizedTestsTemplateOptionScope {
		Facility = 1,
		Global = 2
	}
	export const enum EAndMType {
		Time = 1,
		MedicalDecisionMaking = 2
	}
	export const enum VisitClassificationAdminOptionScope {
		Facility = 1,
		Global = 2
	}
	export const enum YesNoEnums {
		YesValue = -1,
		NoValue = 0,
		BlankValue = 1
	}
	export const enum AccordionSection {
		TabOverviewViewModel = 0,
		TabRangeOfMotionViewModel = 1,
		TabSpecialTestsViewModel = 2,
		TabStrengthSensibilityViewModel = 3,
		TabStaticRepeatedMotionViewModel = 4,
		TabMobilityTestViewModel = 5,
		TabNeuroSpecialTestsViewModel = 6,
		TabExerciseViewModel = 7,
		TabFunctionalTrainingViewModel = 8,
		TabManualTherapyViewModel = 9,
		TabModalitiesViewModel = 10,
		TabEducationViewModel = 11,
		TabEducationViewModelNew = 12,
		TabVestibularSymptomsViewModel = 13,
		TabOculomotorViewModel = 14,
		TabVestibularPositionalTestsViewModel = 15,
		TabOrientationViewModel = 16,
		TabAttentionalProcessViewModel = 17,
		TabMemoryFunctionsViewModel = 18,
		TabLearningAbilitiesViewModel = 19,
		TabProblemSolvingViewModel = 20,
		TabTaskExecutionViewModel = 21,
		TabSelfKnowledgeRegulationViewModel = 22,
		TabArticulationViewModel = 23,
		TabErrorAnalysisViewModel = 24,
		TabDentitionViewModel = 25,
		TabResonanceViewModel = 26,
		TabPhonationViewModel = 27,
		TabRespirationViewModel = 28,
		TabEvaluationTypeViewModel = 29,
		TabLiquidSwallowingViewModel = 30,
		TabSolidsSwallowingViewModel = 31,
		TabSwallowingPrecautionsViewModel = 32,
		TabMuscleTensionEvaluationViewModel = 33,
		TabRespiratorySystemViewModel = 34,
		TabPosturalAlignmentViewModel = 35,
		TabTreatmentActivitiesViewModel = 36,
		TabTreatmentHomeProgramAssignmentsGivenViewModel = 37,
		TabVisionHistoryViewModel = 38,
		TabVisualDemandsViewModel = 39,
		TabBasicVisualSkillsViewModel = 40,
		TabVisualFieldsViewModel = 41,
		TabOculomotorScreeningViewModel = 42,
		TabIntermediateVisualSkillsViewModel = 43,
		TabHighLevelVisualSkillsViewModel = 44,
		TabGeneralViewModel = 45,
		TabTrialsViewModel = 46,
		TabAnalysisViewModel = 47,
		TabDemographicViewModel = 48,
		TabReferenceViewModel = 49,
		TabResultViewModel = 50,
		TabVisionExamGeneralViewModel = 51,
		TabVisionExamVisionTestResultsUncorrectedViewModel = 52,
		TabVisionExamColorBlindnessViewModel = 53,
		TabVisionExamGlassesViewModel = 54,
		TabVisionExamVisionTestResultsCorrectedViewModel = 55,
		TabVisionExamResultsViewModel = 56,
		TabVerbalExpressionViewModel = 57,
		TabWrittenExpressionViewModel = 58,
		TabAugmentativeViewModel = 59,
		TabNoTechViewModel = 60,
		TabLowTechViewModel = 61,
		TabHighTechViewModel = 62,
		TabAuditoryProcessingViewModel = 63,
		TabReadingComprehensionViewModel = 64,
		TabHearingTestResultsViewModel = 65,
		TabResultsViewModel = 66,
		TabExpressiveCommunicationSkillsViewModel = 67,
		TabSchoolLanguageObjectiveViewModel = 68,
		TabSchoolLanguageVocabularySubjectiveViewModel = 69,
		TabSchoolLanguageVocabularyObjectiveViewModel = 70,
		TabPrePeriPostNatalHistoryViewModel = 71,
		TabExpandedPediatricsHistoryViewModel = 72,
		TabEnteralFeedingViewModel = 73,
		TabBreastFeedingViewModel = 74,
		TabBottleFeedingViewModel = 75,
		TabCupStrawDrinkingViewModel = 76,
		TabSolidFoodIntakeViewModel = 77,
		TabImpactCompensationsReducedSpeechIntelligibilityViewModel = 78,
		TabCareProvidersViewModel = 79
	}
	export const enum ReservedTimeSaveType {
		All = 0,
		Future = 1,
		Single = 2
	}
}
module Enums {
	export const enum VisitAppointmentType {
		Appointment = 0,
		Reserved = 1,
		NonBillableInteraction = 2
	}
	export const enum VisitAppointmentReminderStatus {
		CancelRequested = 1,
		Confirmed = 2,
		ReminderSent = 3
	}
}
module Enums {
	export const enum JobClassSetupOptionScope {
		Facility = 1,
		Global = 2
	}
}

export default Enums